module.exports = __webpack_public_path__ + "static/Plaak - 23-Pradel-Light-205TF-19294a2dab261585f2dd320d60da8759.woff";